import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

  transform(bytes: any, decimals = 2): any {
    if (bytes === 0) {
      return '0 Bytes';
    }

    const base = 1024;
    const decimal = decimals < 0 ? 0 : decimals;
    const units = ['Bytes', 'KB', 'MB', 'GB'];

    const i = Math.floor(Math.log(bytes) / Math.log(base));

    return parseFloat((bytes / Math.pow(base, i)).toFixed(decimal)) + ' ' + units[i];
  }

}
